export const generateAnonId = () => {
  const rand =
    Date.now() +
    Math.random()
      .toString(36)
      .substring(2, 6)
  return 'anonymous_' + rand
}

export const createListSeed = (): string =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random()}`
